import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { ClearOutlined } from '@ant-design/icons';
import Pagination from '../paginnation';
import { apiGetPage, apiEditInfo } from '../../request/api'
import NotHaveInfo from '../nothaveinfo';
import { Modal, message, Spin } from 'antd';
import { useCustomData } from '../../pages/context/mineCustomDataProvider';

interface NotificationsProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}
interface OrderItem {
    noticeReciveAt: string | null;
    createdAt: string;
    noticeSendAt: string;
    noticeReceive: string;
    noticeStatus: string;
    noticeType: string;
    id: string;
    noticeSendUser: string;
    notice: string;
}

const Notifications: React.FC<NotificationsProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [activeTab, setActiveTab] = useState<'read' | 'unread' | 'system'>('unread');
    const [isHovered, setIsHovered] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [allNotifications, setAllNotifications] = useState<OrderItem[]>([]);
    const [filteredList, setFilteredList] = useState<OrderItem[]>([]);
    const itemsPerPage = 5;
    const totalItems = filteredList.length;
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';

    const { getValue } = useCustomData();
    const Read = getValue('Read');
    const Unread = getValue('Unread');
    const systemNotice = getValue('systemNotice');
    const allRead = getValue('allRead');
    const msgInfo = getValue('msgInfo');
    const Time = getValue('Time');
    const from = getValue('from');
    const confirmAction = getValue('confirmAction');
    const comfirm = getValue('comfirm');
    const cancel = getValue('cancel');
    const isAllRead = getValue('isAllRead');

    useEffect(() => {
        fetchNotifications();
    }, []);

    useEffect(() => {
        filterNotifications();
    }, [activeTab, allNotifications]);

    const fetchNotifications = () => {
        const userId = localStorage.getItem('userId');
        setLoading(true);

        apiGetPage({
            tid: 'BAEC0EB229C24956AB403F82AC1FAC1E',
            search: 'noticeReceive:' + userId + '/noticeReceive:' + 'all',
            languagecode: languageCode,
            page: 1,
            size: 1000,
        }).then(res => {
            setLoading(false);
            setAllNotifications(res.data.data.rows);
        }).catch(err => {
            console.error(err);
            setLoading(false);
        });
    }

    const filterNotifications = () => {
        let result: OrderItem[] = [];

        switch (activeTab) {
            case 'system':
                // 系统通知：noticeReceive 为 "all"
                result = allNotifications.filter(item =>
                    item.noticeReceive === 'all'
                );
                break;
            case 'read':
                // 已读通知：noticeReceive 不为 "all" 且状态为 "已读"
                result = allNotifications.filter(item =>
                    item.noticeReceive !== 'all' && item.noticeStatus === '已读'
                );
                break;
            case 'unread':
                // 未读通知：noticeReceive 不为 "all" 且状态为 "未读"
                result = allNotifications.filter(item =>
                    item.noticeReceive !== 'all' && item.noticeStatus === '未读'
                );
                break;
        }

        setFilteredList(result);
        setCurrentPage(1); // 切换标签时重置到第一页
    }

    const formatDate = (dateString: string) => {
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                throw new Error('Invalid date');
            }

            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}.${month}.${day}`;
        } catch (error) {
            console.error('日期解析错误:', error);
            return '日期格式错误';
        }
    };

    const handleMarkAllAsRead = async () => {
        try {
            const now = new Date();
            const formattedDate = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')} ${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;

            for (const item of filteredList) {
                await apiEditInfo({
                    tid: 'BAEC0EB229C24956AB403F82AC1FAC1E',
                    id: item.id,
                    noticeReciveAt: formattedDate,
                    noticeStatus: '已读',
                    noticeSendAt: item.noticeSendAt, // 保持原样
                    noticeReceive: item.noticeReceive,
                    noticeType: item.noticeType,
                    noticeSendUser: item.noticeSendUser,
                    notice: item.notice,
                }, {
                    headers: {
                        'Content-Type': 'application/json' // 明确指定内容类型
                    }
                });
            }

            messageApi.open({
                type: 'success',
                content: '全部已读处理成功',
            });

            fetchNotifications();
            setIsModalOpen(false);
        } catch (error) {
            messageApi.open({
                type: 'error',
                content: '处理失败，请稍后重试',
            });
        }
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    // 判断当前标签是否应该显示"全部已读"按钮
    const shouldShowMarkAllButton = () => {
        return activeTab === 'unread';
    }

    return (
        <Spin spinning={loading} tip="">
            <div className="Notifications">
                {contextHolder}
                <div className='notifications-header'>
                    <div
                        onClick={() => setActiveTab('read')}
                        style={{
                            color: activeTab === 'read' ? themeColor : '#8a8eab',
                            cursor: 'pointer'
                        }}
                    >
                        {Read}
                    </div>
                    <div
                        onClick={() => setActiveTab('unread')}
                        style={{
                            color: activeTab === 'unread' ? themeColor : '#8a8eab',
                            cursor: 'pointer',
                            margin: '0 27px'
                        }}
                    >
                        {Unread}
                    </div>
                    <div
                        onClick={() => setActiveTab('system')}
                        style={{
                            color: activeTab === 'system' ? themeColor : '#8a8eab',
                            cursor: 'pointer'
                        }}
                    >
                        {systemNotice}
                    </div>

                    {shouldShowMarkAllButton() && (
                        <div
                            className='notifica-right'
                            style={{
                                color: isHovered ? themeColor : (totalItems === 0 ? '#8a8eab' : 'inherit'),
                                cursor: totalItems === 0 ? 'default' : 'pointer',
                                marginLeft: 'auto'
                            }}
                            onClick={() => totalItems > 0 && setIsModalOpen(true)}
                            onMouseEnter={() => totalItems > 0 && setIsHovered(true)}
                            onMouseLeave={() => totalItems > 0 && setIsHovered(false)}
                        >
                            <ClearOutlined />
                            {allRead}
                        </div>
                    )}
                </div>

                <div className='notificaList-header'>
                    <div>{msgInfo}</div>
                    <div>{Time}</div>
                </div>

                {totalItems !== 0 && (
                    filteredList
                        .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                        .map((item, index) => (
                            <div className="notificaitem" key={index}>
                                <div className='notificaitem-name'>
                                    {item.notice}
                                    {activeTab === 'system' && (
                                        <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
                                            {from}: {item.noticeSendUser}
                                        </div>
                                    )}
                                </div>
                                <div>{formatDate(item.createdAt)}</div>
                            </div>
                        ))
                )}

                <Modal
                    title={confirmAction}
                    open={isModalOpen}
                    onOk={handleMarkAllAsRead}
                    onCancel={handleCancel}
                    okText={comfirm}
                    cancelText={cancel}
                >
                    <p>{isAllRead}</p>
                </Modal>

                {!loading && totalItems === 0 && (
                    <NotHaveInfo />
                )}

                {totalItems > itemsPerPage && (
                    <Pagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        themeColor={themeColor}
                    />
                )}
            </div>
        </Spin>
    );
};

export default Notifications;